module.exports = __webpack_public_path__ + "img/icon-estimate.d1f812e2.svg";